import React, { useMemo } from "react";
import { Link } from "@jsq/ds/core";
import { toDbId } from "#utils/graphql_utils";
type Props = {
  hostName: string;
  positionId: string;
  payee: string;
};

const Payee = ({ hostName = "", positionId = "", payee = "" }: Props) => {
  const positionUrl = useMemo<string>(
    () => `https://${hostName}/position/${toDbId(positionId)}`,
    [hostName, positionId],
  );

  return (
    <Link href={positionUrl} variant="muted" align="left" shouldOpenInNewTab>
      {payee}
    </Link>
  );
};

export default Payee;
